export enum DashboardComponentTypesEnum {
  card = 'card',
  link = 'link',
  list = 'list',
  summary = 'summary',
  tab = 'tab',
  text = 'text',
}

export enum DashboardAlignmentsEnum {
  left = 'left',
  center = 'center',
  right = 'right',
}

export enum TableHeaderTypesEnum {
  integer = 'integer',
  float = 'float',
  string = 'string',
  currency = 'currency',
  month_year = 'month_year',
  full_date = 'full_date',
}

export enum FilterTypesEnum {
  date = 'filter_date',
  non_date = 'filter_non_date',
}

export enum DateIncrementEnum {
  all_time = 'all_time',
  custom = 'custom',
  month = 'month',
  quarter = 'quarter',
  year = 'year',
}

export enum ReportParamsEnum {
  date_increment = 'date_increment',
  report_type = 'report_type',
  years = 'years',
  start_year = 'start_year',
  end_year = 'end_year',
  start_month = 'start_month',
  end_month = 'end_month',
  start_quarter = 'start_quarter',
  end_quarter = 'end_quarter',
}

export enum DateIncrementTrackingEnum {
  month = 'monthly',
  quarter = 'quarterly',
  year = 'annually',
}
